// import dompurify from "dompurify";

export const safeHTML = (html: string) => {
  // const sanitizer = dompurify.sanitize;
  return html; //sanitizer(html);
};
